module.exports = __webpack_public_path__ + "static/media/subscription.7ff577bd.svg";